import jsPDF from 'jspdf';
import { IProjectsOverview } from 'src/common/interfaces/project';
import { getFormattedTime } from 'views/report/utils/utils.ts';
import { fontBold, fontNormal, lineInterval, padding } from 'views/report/utils/style-consts.ts';

export const addHierarchyData = (doc: jsPDF, projectOverview: IProjectsOverview, startY: number = 180) => {
  const hierarchyData = [
    { label: 'Wellbore', value: projectOverview?.wellbore.name },
    { label: 'Well', value: projectOverview.well.name },
    { label: 'Site', value: projectOverview.site.name },
    { label: 'Field', value: projectOverview.field.name },
    { label: 'Country', value: projectOverview.country.name },
    {
      label: 'Start Date',
      value: projectOverview?.startDate ? getFormattedTime(projectOverview?.startDate) : '',
    },
  ];

  const pdfWidth = doc.internal.pageSize.getWidth();

  doc.setFontSize(12);

  // Add bold labels and normal values
  const startX = pdfWidth / 2 - padding / 2; // X coordinate for labels
  const valueX = pdfWidth / 2 + padding / 2; // X coordinate for values
  let currentY = startY; // Starting Y coordinate

  // Loop to add text
  hierarchyData.forEach((item) => {
    // Add bold label
    doc.setFont(fontBold.fontName, fontBold.fontStyle);
    doc.text(`${item.label}`, startX, currentY, { align: 'right' });

    // Add normal value
    doc.setFont(fontNormal.fontName, fontNormal.fontStyle);
    doc.text(`${item.value}`, valueX, currentY, { align: 'left' });

    // Increment Y position for the next row
    currentY += lineInterval;
  });
};
